import RolePermissions from "../crud/rolePermissions";
import PaymentInstances from "../crud/paymentInstances";
import PayoutInstances from "../crud/payoutInstances";
import PDF from "../crud/pdf";
import ReportTypes from "../crud/reportTypes";
import Auth from "../auth";
import PaymentEvents from "../crud/paymentEvents";
import PayoutEvents from "../crud/payoutEvents";
import Users from "../users";
import PaymentRefunds from "../crud/paymentRefunds";
import FiltersCardsWhitelists from "../crud/filtersCardsWhitelists";
import FiltersBins from '../crud/filterBins';
import PaymentOrders from "../crud/paymentOrders";
import PayoutOrders from "../crud/payoutOrders";
import Merchants from "../crud/merchants";
import MerchantTerminals from "../crud/merchantTerminals";
import MerchantTerminalBalances from "../crud/merchantTerminalBalances";
import PublicAggregations from '../crud/publicAggregations';
import PublicCurrencyConversionRate from '../crud/publicCurrencyConversionRate';
import TransactionHistories from '../crud/transactionHistories';
import PublicGateways from '../crud/publicGateways';
import AccountingExternalTransactions from '../crud/accountingExternalTransactions';
import AccountingSystemTransactions from '../crud/accountingSystemTransactions';
import AccountingSystemAccounts from '../crud/accountingSystemAccounts';
import PublicCountries from '../crud/publicCountries';
import PublicTerminalShopWindows from '../crud/publicTerminalShopWindows';
import PublicChargebacks from '../crud/publicChargebacks';
import PublicChargebackComments from '../crud/publicChargebackComments';
import PublicCommissions from '../crud/publicCommissions';
import PublicCommissionTypes from '../crud/publicCommissionTypes';
import CryptoCoins from '../crud/cryptoCoins';
import CryptoPayments from '../crud/cryptoPayments';
import PublicChargebackDocuments from '../crud/publicChargebackDocuments';
import TwoFactorTotp from '../crud/twoFactorTotp';
import Files from '../crud/files';
import PublicFrauds from '../crud/publicFrauds';
import Roles from '../crud/roles';
import PublicFraudComments from '../crud/publicFraudComments';
import PublicFraudDocuments from '../crud/publicFraudDocuments';
import PublicMerchantTerminalGateways from '../crud/publicMerchantTerminalGateways';
import PublicMerchantTerminalPayoutRequests from '../crud/publicMerchantTerminalPayoutRequests';
import RolesActionsPermissions from '../crud/rolesActionsPermissions';
import Providers from '../crud/providers';
import UrlCallbacks from '../crud/urlCallbacks';
import P2PEvents from '../crud/p2pEvents';
import P2PInstances from '../crud/p2pInstances';
import PublicGatewaySettings from '../crud/publicGatewaySettings';
import PublicGatewayApis from '../crud/publicGatewayApis';
import AccountingGatewayTransactions from '../crud/accountingGatewayTransactions';
import AccountingWithdrawalTransactions from '../crud/accountingWithdrawalTransactions';
import PublicAppeals from '../crud/publicAppeals';
import PublicAppealDocuments from '../crud/publicAppealDocuments';
import PublicAgents from '../crud/publicAgents';
import AccountingAgentTransactions from '../crud/accountingAgentTransactions';
import CascadeRules from '../crud/cascadeRules';
import AccountingGatewayAccounts from '../crud/accountingGatewayAccounts';
import PublicAppealComments from '../crud/publicAppealComments';
import PublicGatewayTemplates from '../crud/publicGatewayTemplates';
import AccountingValidationTasks from '../crud/accountingValidationTasks';
import ExportCsvTasks from '../crud/exportCsvTasks';


const ServerConfig = {
    auth: Auth,
    reportTypes: ReportTypes,
    users: Users,
    rolePermissions: RolePermissions,
    PDF: PDF,
    payoutInstances: PayoutInstances,
    payoutEvents: PayoutEvents,
    payoutOrders: PayoutOrders,
    paymentInstances: PaymentInstances,
    paymentEvents: PaymentEvents,
    paymentRefunds: PaymentRefunds,
    paymentOrders: PaymentOrders,
    filtersBins: FiltersBins,
    filtersCardsWhitelists: FiltersCardsWhitelists,
    publicMerchants: Merchants,
    publicMerchantTerminals: MerchantTerminals,
    publicMerchantTerminalBalances: MerchantTerminalBalances,
    publicAggregations: PublicAggregations,
    publicCurrencyConversionRates: PublicCurrencyConversionRate,
    publicTransactionHistories: TransactionHistories,
    publicGateways: PublicGateways,
    accountingExternalTransactions: AccountingExternalTransactions,
    accountingSystemTransactions: AccountingSystemTransactions,
    accountingSystemAccounts: AccountingSystemAccounts,
    publicCountries: PublicCountries,
    publicTerminalShopWindows: PublicTerminalShopWindows,
    publicChargebacks: PublicChargebacks,
    publicChargebackDocuments: PublicChargebackDocuments,
    publicChargebackComments: PublicChargebackComments,
    publicCommissionTypes: PublicCommissionTypes,
    publicCommissions: PublicCommissions,
    cryptoCoins: CryptoCoins,
    cryptoPayments: CryptoPayments,
    totp: TwoFactorTotp,
    files: Files,
    publicFrauds: PublicFrauds,
    roles: Roles,
    publicFraudComments: PublicFraudComments,
    publicFraudDocuments: PublicFraudDocuments,
    publicMerchantTerminalGateways: PublicMerchantTerminalGateways,
    publicMerchantTerminalPayoutRequests: PublicMerchantTerminalPayoutRequests,
    rolesActionsPermissions: RolesActionsPermissions,
    publicProviders: Providers,
    urlCallbacks: UrlCallbacks,
    p2pEvents: P2PEvents,
    p2pInstances: P2PInstances,
    publicGatewaySettings: PublicGatewaySettings,
    publicGatewayApis: PublicGatewayApis,
    accountingGatewayTransactions: AccountingGatewayTransactions,
    accountingWithdrawalTransactions: AccountingWithdrawalTransactions,
    publicAppeals: PublicAppeals,
    publicAppealComments: PublicAppealComments,
    publicAppealDocuments: PublicAppealDocuments,
    publicAgents: PublicAgents,
    accountingAgentTransactions: AccountingAgentTransactions,
    publicCascadeRules: CascadeRules,
    accountingGatewayAccounts: AccountingGatewayAccounts,
    publicGatewayTemplates: PublicGatewayTemplates,
    accountingValidationTasks: AccountingValidationTasks,
    exportCsvTasks: ExportCsvTasks,
};

export class ServerBuilder {
    #serverData = {};

    constructor(serverData) {
        this.#serverData = serverData;
    }

    build() {
        const server = {};
        Object.entries(ServerConfig).forEach(([key, Server]) => {
            server[key] = new Server(this.#serverData);
        });
        return server;
    }
}
